import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { getAllUrlParams } from "../../../../utils/helpers/setAndGetUrlParams";
import { generateQueryParams } from "../../../../utils/helpers/generateQueryParams";
import { useLeadData } from "./useLeadData"; // Assuming it's in the same folder

export const useCachedLeadData = (
  leadId,
  initialDataFromLocation = null,
  forceReload
) => {
  // console.log(forceReload, "forceReload");

  const queryClient = useQueryClient();
  const urlParams = getAllUrlParams();

  const { filters } = useSelector((state) => state.filter);
  const leadsFilters = filters.profilingForm || [];

  const { queryParams, params } = generateQueryParams(leadsFilters);
  console.log(
    "enrollment cache keys are:",
    "profilingForm",
    urlParams?.page * 1,
    urlParams?.limit * 1,
    params?.toString(),
    queryParams?.toString(),
    urlParams?.companyid,
    "-createdAt"
  );
  const allLeadsData = queryClient.getQueryData([
    "profilingForm",
    urlParams?.page * 1,
    urlParams?.limit * 1,
    params?.toString(),
    queryParams?.toString(),
    urlParams?.companyid,
    "-createdAt",
  ])?.data?.data;

  const cachedLeadData = allLeadsData?.find((lead) => lead._id === leadId);

  let shouldFetchFresh = forceReload || !cachedLeadData;
  if (!leadId) {
    shouldFetchFresh = false; // If no leadId is provided, always fetch fresh data
  }
  console.log(
    "cachedLeadData",
    cachedLeadData,
    "for leadId",
    leadId,
    "and shouldFetchFresh",
    shouldFetchFresh
  );

  const {
    leadData: fetchedLeadData,
    isLoading,
    isError,
    error,
  } = useLeadData(leadId, shouldFetchFresh);

  const leadData = shouldFetchFresh
    ? fetchedLeadData
    : cachedLeadData || initialDataFromLocation;

  return {
    leadData,
    isLoading,
    isError,
    error,
  };
};
